import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// Angular Material
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';

// Custom services
import { ControllerService } from '../../../services/controller/controller.service';
import { LanguageService } from '../../../services/language/language.service';
import { UtilsService } from '../../../services/utils/utils.service';
import { SpreadsheetService } from '../../../services/spreadsheet/spreadsheet.service';

// Custom components
import { WaitingPopupComponent } from '../../popups/waiting-popup/waiting-popup.component';

// Constant configuration values
import { configurationValues } from '../../../constants/global';


@Component({
  selector: 'app-analysis-count',
  imports: [
    CommonModule,     // *ngIf
    FormsModule,      // [(ngModel)]
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    // Custom components
    WaitingPopupComponent
  ],
  templateUrl: './analysis-count.component.html',
  styleUrl: './analysis-count.component.css'
})
export class AnalysisCountComponent {

  // Waiting popup info
  displayWaitingPopup = false
  waitingMessage = ''

  // Menu list values
  optionMenu_Region_OptionList = configurationValues.regionList

  // Parámetros Globales
  globalFilters = {
    startDate: null,
    endDate: null,
    region: this.optionMenu_Region_OptionList[0]
  };

  // Parámetros Específicos
  inputs = {
    userEmail: '',
    domainNameCount: '',
    domainNameActivity: ''
  };

  // Resultados
  results = {
    userCount: null as number | null,
    domainCount: null as number | null,
    globalCount: null as number | null
  };

  // Constructor
  constructor(
    public controllerService:ControllerService,
    public languageService:LanguageService,
    public utilsService:UtilsService,
    public spreadsheetService:SpreadsheetService,
  ){}

  // Métodos de llamada a la API (Ejemplos)
  async getUserAnalysisCount() {
    // Get the global parameters
    const startDate = this.formatDate(this.globalFilters.startDate)
    const endDate = this.formatDate(this.globalFilters.endDate)
    const region = this.globalFilters.region
    // Get the input parameters
    const email = this.inputs.userEmail 
    // Validate parameters
    if (!startDate || !endDate || !region || !email) return
    // Display waiting popup
    this.waitingMessage = this.languageService.Strings.messages.info_gettingInformation
    this.displayWaitingPopup = true
    // Execute request
    const resultDict = await this.controllerService.analysisCount_userAnalysisCount(region, email, startDate!, endDate!)
    this.displayWaitingPopup = false
    // Manage the result
    if(!resultDict['success']) return
    // Display value
    this.results.userCount = resultDict['result']['total']
  }

  async getDomainAnalysisCount() {
    // Get the global parameters
    const startDate = this.formatDate(this.globalFilters.startDate)
    const endDate = this.formatDate(this.globalFilters.endDate)
    const region = this.globalFilters.region
    // Get the input parameters
    const domain = this.inputs.domainNameCount 
    // Validate parameters
    if (!startDate || !endDate || !region || !domain) return
    // Display waiting popup
    this.waitingMessage = this.languageService.Strings.messages.info_gettingInformation
    this.displayWaitingPopup = true
    // Execute request
    const resultDict = await this.controllerService.analysisCount_domainAnalysisCount(region, domain, startDate!, endDate!)
    this.displayWaitingPopup = false
    // Manage the result
    if(!resultDict['success']) return
    // Display value
    this.results.domainCount = resultDict['result']['total']
  }

  async getGlobalAnalysisCount() {
    // Get the global parameters
    const startDate = this.formatDate(this.globalFilters.startDate)
    const endDate = this.formatDate(this.globalFilters.endDate)
    const region = this.globalFilters.region
    // Validate parameters
    if (!startDate || !endDate || !region) return
    // Display waiting popup
    this.waitingMessage = this.languageService.Strings.messages.info_gettingInformation
    this.displayWaitingPopup = true
    // Execute request
    const resultDict = await this.controllerService.analysisCount_globalAnalysisCount(region, startDate!, endDate!)
    this.displayWaitingPopup = false
    // Manage the result
    if(!resultDict['success']) return
    // Download excel
    this.spreadsheetService.generateDomainReport(resultDict['result'], 'domain_activity')
    // Display the global value
    this.results.globalCount = this.sumTotalAnalysis(resultDict['result'])
  }

  async getDomainActivity() {
    // Get the global parameters
    const startDate = this.formatDate(this.globalFilters.startDate)
    const endDate = this.formatDate(this.globalFilters.endDate)
    const region = this.globalFilters.region
    // Get the input parameters
    const domain = this.inputs.domainNameActivity 
    // Validate parameters
    if (!startDate || !endDate || !region || !domain) return
    // Display waiting popup
    this.waitingMessage = this.languageService.Strings.messages.info_gettingInformation
    this.displayWaitingPopup = true
    // Execute request
    const resultDict = await this.controllerService.analysisCount_domainActivity(region, domain, startDate!, endDate!)
    this.displayWaitingPopup = false
    // Manage the result
    if(!resultDict['success']) return
    // Download excel
    this.spreadsheetService.generateDomainReport(resultDict['result'], 'global_activity')
  }

  



  // ----- Internal methods ------ //
  private formatDate(date: Date | null): string | null {
    if (!date) return null;
    const year = date.getFullYear();
    // date.getMonth() va de 0 a 11, le sumamos 1. padStart asegura que siempre tenga 2 dígitos.
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}${month}${day}`;
  }


  valid_getUserAnalysisCount(){
    // Get the global parameters
    const startDate = this.formatDate(this.globalFilters.startDate)
    const endDate = this.formatDate(this.globalFilters.endDate)
    const region = this.globalFilters.region
    // Get the input parameters
    const email = this.inputs.userEmail 
    // Validate the parameters
    if (!startDate || !endDate || !region || !email) return false
    return true
  }

  valid_getDomainAnalysisCount(){
    // Get the global parameters
    const startDate = this.formatDate(this.globalFilters.startDate)
    const endDate = this.formatDate(this.globalFilters.endDate)
    const region = this.globalFilters.region
    // Get the input parameters
    const domain = this.inputs.domainNameCount 
    // Validate the parameters
    if (!startDate || !endDate || !region || !domain) return false
    return true
  }

  valid_getDomainActivity(){
    // Get the global parameters
    const startDate = this.formatDate(this.globalFilters.startDate)
    const endDate = this.formatDate(this.globalFilters.endDate)
    const region = this.globalFilters.region
    // Get the input parameters
    const domain = this.inputs.domainNameActivity 
    // Validate the parameters
    if (!startDate || !endDate || !region || !domain) return false
    return true
  }

  valid_getGlobalAnalysisCount(){
    // Get the global parameters
    const startDate = this.formatDate(this.globalFilters.startDate)
    const endDate = this.formatDate(this.globalFilters.endDate)
    const region = this.globalFilters.region
    // Validate the parameters
    if (!startDate || !endDate || !region) return false
    return true
  }

  sumTotalAnalysis(resultList:any){
    const sumaTotal = resultList.reduce((acumulador:number, elementoActual:any) => {
      return acumulador + elementoActual.total;
    }, 0);
    return sumaTotal
  }


}
